<script lang="ts" setup>
import { ref } from 'vue';

import { validateNoSpecialCharacters, TextField } from '@idem/ui';

const emit = defineEmits(['update', 'error']);
const { firstName } = defineProps<{ firstName?: string }>();
const errorCaption = ref('');

const validateInput = validateNoSpecialCharacters;
</script>

<template>
  <TextField
    :validator="validateInput"
    :value="firstName"
    field="nombre"
    label="Nombre"
    @error="e => emit('error', e)"
    @update="e => emit('update', e)"
  />
</template>

<style scoped></style>
